import React, { useContext, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ImCross } from "react-icons/im";
import { HiOutlineCalendar } from "react-icons/hi";
import Step4 from "../../pages/Evaluation New/Step4";
import FeedbackContext from "../../context/cmscontext";
import { TOASTER_SHOW, toaster_s } from "../../constant";

export default function AppointmentEditModal({
  appointmentId,
  updateIndex = 0,
  onClose,
  title,
  description,
}) {
  const dispatch = useDispatch();
  const openedAtRef = useRef(Date.now());
  const lastAppointmentSave = useSelector(
    (state) => state.sellMyCar.last_appointment_save
  );
  const { feedback } = useContext(FeedbackContext);
  const evaluation_page = feedback.evaluation_page || {};
  const car_steps_page = feedback.car_steps_page || {};

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  useEffect(() => {
    if (
      !lastAppointmentSave ||
      lastAppointmentSave.at < openedAtRef.current ||
      lastAppointmentSave.status !== "success"
    ) {
      return;
    }

    dispatch({
      type: TOASTER_SHOW,
      payload: {
        show: true,
        autoHide: true,
        type: toaster_s,
        heading:
          evaluation_page.Appointment_updated_heading || "Appointment updated",
        description:
          evaluation_page.Appointment_updated_message ||
          "Your appointment has been saved successfully.",
      },
    });
    onClose();
  }, [lastAppointmentSave, onClose, dispatch, evaluation_page]);

  return (
    <div className="pi-appointment-edit__backdrop" role="presentation" onClick={onClose}>
      <div
        className="pi-appointment-edit__modal pi-book-appointment"
        role="dialog"
        aria-modal="true"
        aria-labelledby="appointment-edit-title"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="pi-appointment-edit__close"
          onClick={onClose}
          aria-label="Close"
        >
          <ImCross size={14} />
        </button>

        <header className="pi-appointment-edit__head">
          <span className="pi-book-appointment__eyebrow pi-book-appointment__eyebrow--accent">
            <HiOutlineCalendar size={16} aria-hidden />
            {evaluation_page.Your_appointment_text || "Your appointment"}
          </span>
          <h2 id="appointment-edit-title">
            {title ||
              car_steps_page.Book_Appoinment_Details ||
              "Update your appointment"}
          </h2>
          <p>
            {description ||
              car_steps_page.Book_Appoinment_Information ||
              "Change your inspection centre, date, or time slot."}
          </p>
        </header>

        <div className="pi-appointment-edit__body">
          <div className="pi-book-appointment__form-shell">
            <Step4
              name="update"
              appointmentId={appointmentId}
              updateIndex={updateIndex}
              formanimationClassname="pi-book-appointment__animate-in"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
